export default "__VITE_ASSET__DxDL2BeR__"